import React, { useState } from 'react';
import { Icon } from './lib';
import { api } from './api';

export default function Login({ onLogin, note }) {
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const d = await api.login(pw);
      if (d.token) onLogin(d.token);
      else setErr('That password did not work.');
    } catch (ex) {
      setErr(ex.status === 401 ? 'That password did not work.' : ex.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="tg-login">
      <form className="panel tg-login-box" onSubmit={submit}>
        <div className="tg-login-mark"><Icon name="server" size={26}/></div>
        <h1 className="tg-login-title">teg<span className="tg-dot">.</span></h1>
        <p className="tg-login-sub">System console for the disinteg box</p>
        {note && <div className="alert alert--info tg-banner">{note}</div>}
        <div className="field tg-field">
          <label htmlFor="tg-pw">Password</label>
          <input id="tg-pw" className="input" type="password" autoFocus autoComplete="current-password"
                 value={pw} onChange={(e) => setPw(e.target.value)}/>
        </div>
        <button type="submit" className="btn tg-login-btn" disabled={busy}>{busy ? 'Checking…' : 'Unlock'}</button>
        {err && <div className="alert alert--err tg-banner">{err}</div>}
      </form>
    </div>
  );
}
